module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"maximumFileSize":"Maximale Dateigröße: {maxSize} kB","theMaximumFileSizeOfWasExceeded":"Die maximale Dateigröße von {maxSize} kB wurde überschritten."},"en":{"maximumFileSize":"Maximum file size: {maxSize} kB","theMaximumFileSizeOfWasExceeded":"The maximum file size of {maxSize} kB was exceeded."}}')
  delete Component.options._Ctor
}
